__turbopack_context__.v({
  "bounceInLeft": "index-module-scss-module__khqCuq__bounceInLeft",
  "confirmMessage": "index-module-scss-module__khqCuq__confirmMessage",
  "show": "index-module-scss-module__khqCuq__show",
});
